<template>
  <account-reset-submit platform="portal"/>
</template>

<script>
import AccountResetSubmit from '../../components/assemble-account/AccountResetSubmit.vue';

export default {
  name: 'ResetSubmit',
  components: {
    AccountResetSubmit
  }
};
</script>

<style scoped lang="scss">
</style>
